<!--
 * @Author: cryi.liu
 * @Date: 2020-05-09 10:45:37
 * @LastEditTime: 2020-07-16 18:11:43
 * @Description: 生成试卷设置
 -->
<template>
  <div class="generate-test-paper-setting">
    <setting-exam-time-and-exam-pass-score />
    <add-exam-object
      v-if="showAddExamObject"
      :exam-id="examId" />
    <selected-exam-object />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import SelectedExamObject from './SelectedExamObject.vue';
import AddExamObject from './AddExamObject.vue';
import SettingExamTimeAndExamPassScore from './SettingExamTimeAndExamPassScore.vue';

export default {
  name: 'GenerateTestPaperSetting',
  components: {
    SelectedExamObject,
    SettingExamTimeAndExamPassScore,
    AddExamObject,
  },
  props: {
    examId: { type: [Number, String], required: false },
  },
  data() {
    return {
      showAddExamObject: true,
      canAddExamObject: true,
      canUploadExcel: true,
    };
  },
  computed: {
    ...mapGetters({
      pageType: 'createPaperStore/pageType',
    }),
  },
  watch: {
    pageType: {
      immediate: true,
      handler(pageType) {
        if (pageType === 'create') {
          this.showAddExamObject = true;
        } else if (pageType === 'edit') {
          this.showAddExamObject = false;
        }
      },
    },
  },
};
</script>

<style lang="less" scoped>
.generate-test-paper-setting {
  margin-top: 32px;
  width: 100%;
}
</style>
